// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.8164 5.33081L21.8584 18.8289H21.8506L21.8564 18.8318L16.9639 21.5603L16.4736 21.8328L15.9854 21.5583L11.9775 19.2986V13.2302L16.5 15.7937V8.11499L12.3486 4.93726L17.4805 2.27417L21.8164 5.33081ZM11.998 4.88257L11.9971 10.8796L7.36328 8.27612V15.9763L11.541 19.1755L6.80664 21.5173L6.26758 21.783L2.04688 18.7556L2.00391 6.26147L2.00195 5.26538L1.99902 5.2644L2.00195 5.26245L2.00098 5.26147L2.00488 5.2605L6.89941 2.53198L7.3916 2.25659L11.998 4.88257ZM13.9775 18.1296L16.4785 19.5398L17.7754 18.8162L13.9775 16.6628V18.1296ZM4.04297 17.7263L6.45703 19.4578L7.77051 18.8083L5.36328 16.9646V7.15308L4.00391 6.39038L4.04297 17.7263ZM16.0635 5.26245L18.1074 6.82788L18.5 7.12769V16.9275L19.8545 17.696L19.8193 6.36987L17.3223 4.60913L16.0635 5.26245ZM6.09375 5.27026L9.99707 7.46265V6.0437L7.37988 4.55249L6.09375 5.27026Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-hiflow')
export default class LogoHiflowIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-hiflow',
    }
  }
}
